import React from 'react';
import styled from 'styled-components/macro';

import { Note } from '../../../components/forms/FormStyles';
import ExternalLink from '../../../components/standard/ExternalLink';

const Waiver = styled.div`
  p {
    padding-bottom: 20px;
  }
`;

const WaiverNote = styled(Note)`
  && {
    margin-bottom: 30px;
    padding-top: 25px;
    line-height: 168%;
    padding-bottom: 50px;
  }
`;
const RennocoFormWaiver = ({ children }) => (
  <Waiver>
    <WaiverNote>
      <div>
        <p style={{ fontWeight: 'bold' }}>
          {`By clicking "I Agree" and subject to conflicts check and
          KYC, you have read the `}
          <ExternalLink
            href="https://www.rennoco.com/terms-of-services"
            target="_blank"
            rel="noopener
          noreferrer"
          >
            terms and conditions
          </ExternalLink>
          {` and the `}
          <ExternalLink
            href="https://www.rennoco.com/privacy-policy"
            target="_blank"
            rel="noopener
          noreferrer"
          >
            privacy policy
          </ExternalLink>
          {` as well as the mandate agreement between Renno & Co Inc. and you and
          you have agreed to its terms and have agreed it pay this retainer.`}
        </p>
        {children}
      </div>
    </WaiverNote>
  </Waiver>
);

export default RennocoFormWaiver;
